import {ProspectPool, useCurrentClientQuery} from 'api';
import React from 'react';
import {Link} from 'react-router-dom';
import Copy from './Copy';

interface Props {
  prospectPool: ProspectPool;
}

export default ({prospectPool}: Props) => {
  const {data: {currentClient = {}} = {}} = useCurrentClientQuery({
    fetchPolicy: 'cache-and-network',
  });
  const account = prospectPool.prospect.account;
  const prospect = prospectPool.prospect;

  return (
    <div className="flex flex-col gap-1 items-start">
      <div className="flex items-center">
        <div className="mr-2">
          <Link
            to={`/pools/${prospectPool.pool.uuid}/accounts/${prospectPool.accountPool.uuid}`}
            target="_blank">
            {account.name}
          </Link>
        </div>
        {account.name && <Copy copyText={account.name} />}
      </div>
      {account.webSite && (
        <div className="flex items-center gap-2">
          <span className="text-xs text-gray-400 w-8">URL</span>
          <a href={account.webSite} target="_blank">
            {account.webSite}
          </a>
          {account.webSite && <Copy copyText={account.webSite} />}
        </div>
      )}
      {prospect.section && (
        <div className="flex items-center gap-2">
          <span className="text-xs text-gray-400 w-8">部署</span>
          <span>{prospect.section}</span>
        </div>
      )}
      {prospect.sectionPosition && (
        <div className="flex items-center gap-2">
          <span className="text-xs text-gray-400 w-8">役職</span>
          <span>{prospect.sectionPosition}</span>
        </div>
      )}
      {prospect.telephoneNumber && (
        <div className="flex items-center gap-2">
          <span className="text-xs text-gray-400 w-8">TEL</span>
          <a
            href={
              currentClient.zoomPhoneActive
                ? `zoomphonecall:${prospect.telephoneNumber}`
                : `tel:${prospect.telephoneNumber}`
            }>
            {prospect.telephoneNumber}
          </a>
          {prospect.telephoneNumber && (
            <Copy copyText={prospect.telephoneNumber} />
          )}
        </div>
      )}
      {prospect.email && (
        <div className="flex items-center gap-2">
          <span className="text-xs text-gray-400 w-8">email</span>
          <span>{prospect.email}</span>
          {prospect.email && <Copy copyText={prospect.email} />}
        </div>
      )}
    </div>
  );
};
